// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mt14[data-v-495d1984] { margin-top: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
